import styled from '@emotion/styled';
import { css } from '@emotion/react';

import { FlexItem } from '../Flex';

import type { FlexItemProps } from '../Flex';
import type { BreakpointUnit } from '@toolbox/style';
import type { CSSInterpolation } from '@emotion/serialize';

export const gridSizeList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12] as const;
export type GridSize = (typeof gridSizeList)[number];

export type BreakPointOrderProp = `order${BreakpointUnit}`;

export type GridSizeProps = Partial<Record<BreakpointUnit, GridSize | true>>;
export type GridOrderProps = Partial<Record<BreakPointOrderProp, string | undefined | null>>;

export type GridItemProps = FlexItemProps &
  GridSizeProps &
  GridOrderProps & {
    hideUnderBreakpoint?: BreakpointUnit | null | undefined | '';
    customStyle?: string | null | undefined;
  };

export const GridItem = styled(FlexItem)<GridItemProps>`
  ${({ theme, ...props }) =>
    Object.keys(theme.breakpoints).map((bpu) => {
      const bp = bpu as BreakpointUnit;
      const propBp = props[bp] as GridSize | boolean;
      return (
        propBp &&
        (bp === 'xs'
          ? colStyles(propBp, theme.grid.columns)
          : css`
              ${theme.media.up(bp)} {
                ${colStyles(propBp, theme.grid.columns)}
              }
            `)
      );
    })}

  ${({ theme, ...props }) =>
    Object.keys(theme.breakpoints).map((bpu) => {
      const bp = bpu as BreakpointUnit;
      const propBp = props[`order${bp}`];
      return (
        propBp &&
        (bp === 'xs'
          ? `order: ${propBp}`
          : css`
              ${theme.media.up(bp)} {
                order: ${propBp};
              }
            `)
      );
    })}

    ${({ theme, ...props }) => {
    return props.customStyle;
  }}

    ${({ theme, ...props }) => {
    return props.hideUnderBreakpoint
      ? `${theme.media.down(props.hideUnderBreakpoint)} {
          display: none;
        }`
      : '';
  }}
`;

GridItem.defaultProps = {
  xs: 12,
};

function colStyles(colSize: GridSize | true, columns: number): CSSInterpolation {
  return colSize === true ? dynamicColStyles() : fixedColStyles(colSize, columns);
}

function fixedColStyles(colSize: GridSize, columns: number): string {
  return `
  flex-grow: 0;
  max-width: ${(100 / columns) * colSize}%;
  flex-basis: ${(100 / columns) * colSize}%;
`;
}

function dynamicColStyles(): string {
  return `
  flex-grow: 1;
  max-width: 100%;
  flex-basis: 0;
`;
}
